// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-container{display:flex!important}.loading-container__spinner{animation:rotate 1.5s linear infinite;height:40px;width:40px}@media(max-width:768px){.loading-container__spinner{height:30px;width:30px}}.loading-style{bottom:25px;height:40px;pointer-events:none;position:fixed;right:25px;width:40px;z-index:90}@media(max-width:768px){.loading-style{bottom:80px;right:10px}}@keyframes rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
